import { render } from "./gang-start-action.vue?vue&type=template&id=1a5cf317"
import script from "./gang-start-action.vue?vue&type=script&lang=js"
export * from "./gang-start-action.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__